import React from 'react';
import Logo from './Logo';
import './Footer.css';

const Footer = () => {
  const goHome = () => {
    if (window.location.pathname === '/') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      window.location.href = '/';
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-col footer-col-brand">
            <div className="brand-group" onClick={goHome} style={{ cursor: 'pointer' }}>
              <Logo variant="dark" size="medium" onClick={goHome} />
              <span className="brand-name">Scan2Card</span>
            </div>
            <h4 className="footer-heading">Address</h4>
            <address className="footer-address">
              Office No. 236, Adarsh Industrial Estate,<br />
              Sahar Airport Road, Chakala, Andheri (East),<br />
              Mumbai - 400099, Maharashtra, India.
            </address>
            <div className="ieia-inline">
              <img
                src="/assets/Scan2CardLogos/IEIA-logo.png"
                alt="IEIA"
                className="ieia-inline-logo"
              />
              <div className="ieia-inline-text">
                <span className="ieia-inline-title">IEIA Member</span>
                <span className="ieia-inline-sub">Associate Tier</span>
              </div>
            </div>
          </div>

          <div className="footer-col">
            <h4 className="footer-heading">Industry Standards</h4>
            <a
              href="https://drive.google.com/file/d/1Wumx0ziGqPyCVX2_fUM94TUgRpWLOsVd/view?usp=sharing"
              target="_blank"
              rel="noopener noreferrer"
              className="standard-card standard-card-btn"
              aria-label="View ISO 9001:2015 certificate PDF"
            >
              <img
                src="/assets/Scan2CardLogos/iso2015image.jpg"
                alt="ISO 9001:2015"
                className="standard-card-logo"
              />
              <div className="standard-card-text">
                <span className="standard-card-title">ISO 9001:2015</span>
                <span className="standard-card-sub">Certified Operations</span>
              </div>
            </a>
            <a
              href="https://drive.google.com/file/d/1MT0-e1ragVPJloaGd1Ljjqchmo5iB-E-/view?usp=sharing"
              target="_blank"
              rel="noopener noreferrer"
              className="standard-card standard-card-btn"
              aria-label="View ISO 9001:2022 certificate PDF"
            >
              <img
                src="/assets/Scan2CardLogos/iso2022image.png"
                alt="ISO 9001:2022"
                className="standard-card-logo"
              />
              <div className="standard-card-text">
                <span className="standard-card-title">ISO 9001:2022</span>
                <span className="standard-card-sub">Certified Operations</span>
              </div>
            </a>
          </div>

          <div className="footer-col">
            <h4 className="footer-heading">Resources</h4>
            <div className="footer-links">
              <a href="/privacy-policy">Privacy Policy</a>
              <a href="/terms-conditions">Terms &amp; Conditions</a>
              <a href="/disclaimer">Disclaimer</a>
              <a href="/cookie-policy">Cookie Policy</a>
            </div>
          </div>

          <div className="footer-col">
            <h4 className="footer-heading">Connect</h4>
            <div className="footer-socials">
              <a
                href="https://www.linkedin.com/company/110360097/"
                aria-label="LinkedIn"
                title="LinkedIn"
                className="social-icon"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.063 2.063 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                </svg>
              </a>
              <a
                href="https://www.instagram.com/scan2cardindia/"
                aria-label="Instagram"
                title="Instagram"
                className="social-icon"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z" />
                </svg>
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61591549960123"
                aria-label="Facebook"
                title="Facebook"
                className="social-icon"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                </svg>
              </a>
              <a
                href="https://x.com/Scan2Card"
                aria-label="X (Twitter)"
                title="X (Twitter)"
                className="social-icon"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                </svg>
              </a>
              <a
                href="https://www.youtube.com/@Scan2CardIndia"
                aria-label="YouTube"
                title="YouTube"
                className="social-icon"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                </svg>
              </a>
              <a
                href="https://wa.me/919136836718"
                aria-label="WhatsApp"
                title="WhatsApp"
                className="social-icon"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.693.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z" />
                </svg>
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2024 Scan2Card. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
